export * from './cep-mask.pipe';
export * from './telefone-mask.pipe';
export * from './html-sanitizer.pipe';
export * from './capitalize-first.pipe';
export * from './cpf-mask.pipe';
export * from './cpfCnpj.pipe';


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/pipes/index.ts